import { getDisplayVersion, getIgnoreScopeLabel } from '../../../../shared/issuesV2';
import type { ExceptionIgnoreScope, ExceptionPackageScope } from '../../../../shared/issuesV2';
import type { LocatorParts } from '../../../../shared/Locator';

/**
 * Provides a human readable version, taking into account package scoping
 * @param packageScope {ExceptionPackageScope} Package scoping
 * @param revision {LocatorParts} Revision with version
 * @returns {string} 'All' or human readable version (linux parsed)
 */
export const getHumanReadableVersion = (packageScope: ExceptionPackageScope, revision: LocatorParts | null) =>
  getDisplayVersion(packageScope, revision);

/**
 * Provides a human readable ignore scope
 * @param {ExceptionIgnoreScope} ignoreScope Ignore scope for the exception
 */
export const getBadgeTextForIgnoreScope = (ignoreScope: ExceptionIgnoreScope) =>
  getIgnoreScopeLabel(ignoreScope);
